import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { headersType } from "../../../utils/constants/headersForApi";

export const notificationUserApi = createApi({
    reducerPath: "userNotification",
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL,
    }),
    tagTypes: ["notification"],
    endpoints: (builder) => ({
        notificationList: builder.query({
            query: () => ({
                url: "/Notification",
                method: "POST",
                headers: headersType(),
                body: {
                    startRow: 0,
                    endRow: 10,
                    sort: [
                        {
                            colId: "createdAt",
                            sortDirection: "desc",
                            sortIndex: 0,
                        }
                    ]
                }
            }),
            providesTags: ["notification"]
        }),

        readNotification: builder.mutation({
            query: (id) => ({
                url: `/Notification/${id}/setread`,
                method: "POST",
                headers: headersType(),
                body: { id }


            }),
            invalidatesTags: ["notification"]
        }),

    })
})

export const { useNotificationListQuery, useReadNotificationMutation } = notificationUserApi